import script from "./unpaid.vue?vue&type=script&lang=ts&setup=true"
export * from "./unpaid.vue?vue&type=script&lang=ts&setup=true"

import "./unpaid.vue?vue&type=style&index=0&id=4980762e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4980762e"]])

export default __exports__